/*
  GiftGo product-card add-to-cart icon button.

  Adds the card product's first available variant to the cart over Dawn's cart
  AJAX, then lets Dawn's own cart UI (cart-notification or cart-drawer) re-render
  its sections, so the cart count bubble and the cart update exactly as they do
  from the product page. No page reload. Reuses Dawn globals: fetchConfig,
  routes, PUB_SUB_EVENTS, publish.
*/
(function () {
  'use strict';

  class GiftGoAddToCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (this.button && !this.bound) {
        this.bound = true;
        this.button.addEventListener('click', this.onClick.bind(this));
      }
    }

    onClick(event) {
      event.preventDefault();
      event.stopPropagation();

      var variantId = this.dataset.variantId;
      if (!variantId || this.loading) return;

      this.loading = true;
      this.classList.add('is-loading');
      this.button.setAttribute('aria-busy', 'true');

      var cart =
        document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (s) {
            return s.id;
          })
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(function (response) {
          return response.json();
        })
        .then(
          function (response) {
            if (response.status) {
              // Sold out / not addable. Leave the page as is.
              return;
            }
            // Buy now: item is in the cart, go straight to checkout.
            if (this.dataset.buyNow) {
              window.location.href = '/checkout';
              return;
            }
            this.flyToCart();
            this.markAdded();
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'giftgo-card-add', productVariantId: variantId });
            }
          }.bind(this)
        )
        .catch(function () {})
        .finally(
          function () {
            this.loading = false;
            this.classList.remove('is-loading');
            this.button.removeAttribute('aria-busy');
          }.bind(this)
        );
    }

    // Brief success state on the button (green tick pulse), then revert.
    markAdded() {
      this.classList.add('is-added');
      window.clearTimeout(this._addedTimer);
      this._addedTimer = window.setTimeout(
        function () {
          this.classList.remove('is-added');
        }.bind(this),
        1100
      );
    }

    // Clone the card's product image and animate it into the header cart icon.
    flyToCart() {
      if (reduceMotion()) return;
      var cartIcon = document.getElementById('cart-icon-bubble');
      var container = this.closest(
        '.giftgo-rail__item, .giftgo-upsell__item, .card-wrapper, .product-card-wrapper, .grid__item'
      );
      var img = container ? container.querySelector('img') : null;
      if (!cartIcon || !img) return;

      var from = img.getBoundingClientRect();
      var to = cartIcon.getBoundingClientRect();
      if (!from.width || !to.width) return;

      var clone = img.cloneNode(true);
      clone.removeAttribute('loading');
      clone.removeAttribute('srcset');
      clone.className = 'giftgo-fly';
      clone.style.left = from.left + 'px';
      clone.style.top = from.top + 'px';
      clone.style.width = from.width + 'px';
      clone.style.height = from.height + 'px';
      document.body.appendChild(clone);

      var dx = to.left + to.width / 2 - (from.left + from.width / 2);
      var dy = to.top + to.height / 2 - (from.top + from.height / 2);

      // Next frame so the start position is committed before transitioning.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)';
          clone.style.opacity = '0.25';
        });
      });

      var done = function () {
        if (clone.parentNode) clone.parentNode.removeChild(clone);
      };
      clone.addEventListener('transitionend', done);
      window.setTimeout(done, 1000);
    }
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Bump the header cart bubble on every cart update, so any add (cards, upsell,
  // product page) gives a small confirming pulse.
  function bumpCartBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    bubble.classList.remove('giftgo-bump');
    void bubble.offsetWidth; // restart the animation
    bubble.classList.add('giftgo-bump');
  }

  // Periodic reminder: while the cart has items, give the header cart icon a
  // gentle bell-shake every few seconds so the shopper remembers to check out.
  // Stops when the cart is empty and skips a beat while they are viewing the cart.
  var remindTimer = null;

  function cartHasItems() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    return !!bubble && bubble.textContent.trim() !== '';
  }

  function shakeCartIcon() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) return; // already reviewing
    icon.classList.remove('giftgo-remind');
    void icon.offsetWidth; // restart
    icon.classList.add('giftgo-remind');
  }

  function updateCartReminder() {
    if (cartHasItems()) {
      if (!remindTimer) remindTimer = window.setInterval(shakeCartIcon, 6000);
    } else if (remindTimer) {
      window.clearInterval(remindTimer);
      remindTimer = null;
    }
  }

  if (!customElements.get('giftgo-add-to-cart')) {
    customElements.define('giftgo-add-to-cart', GiftGoAddToCart);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      bumpCartBubble();
      updateCartReminder();
    });
  }

  updateCartReminder();
})();
